import moment from "moment";
import jwt_decode from "jwt-decode";
import React, { useEffect, useRef, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import Select from "react-select";
import { RSAencryptData } from "./RSAEnc";
import { DELETE_REQUEST_DOC, DOWNLOAD_REQUEST_DOC, POST_DELETE_TRANS_FILE } from "../APIS";
import { openModal, PopUpMessage } from "../../../Library/ModalPopUp";

const customStyles = {
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
};

const doc_type = [
  { id: "strg.doc.type.ktp", name: "KTP" },
  { id: "strg.doc.type.pasfoto", name: "Pass Photo" },
  { id: "strg.doc.type.familycertificate", name: "Family Certificate" },
  { id: "strg.doc.type.birthcertificate", name: "Birth Certificate" },
  { id: "strg.doc.type.reportcards'", name: "Report Cards" },
  { id: "strg.doc.type.ijazah", name: "Ijazah" },
  { id: "strg.doc.type.passport", name: "Passport" },
  { id: "strg.doc.type.certificate", name: "Certification" },
  { id: "strg.doc.type.recommendationletter", name: "Recommendation Letter" },
];

const DocumentType = ({ data, setData, disabled = false, required }) => {
  const listdata = doc_type.map((v) => {
    return { value: v.id, label: v.name };
  });

  const [selected, setSelected] = useState(
    listdata.find((v) => v.value === data) || ""
  );

  const HandlerChange = (value) => {
    setSelected(value);
    setData(value);
  };

  return (
    <div className="form-group mb-5">
      <label className={"form-label fw-bold " + (required && "required")}>
        Document Type
      </label>
      <Select
        name="course_owner"
        classNamePrefix="react-select"
        value={selected}
        onChange={HandlerChange}
        isDisabled={disabled}
        options={listdata}
        styles={customStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  );
};

const MimeFile = ({ data }) => {
  let icons = "far fa-file-alt";
  if (data.mimetype === "application/pdf") {
    icons = "far fa-file-pdf";
  } else if (data.mimetype.includes("image")) {
    icons = "flaticon2-image-file";
  }
  return (
    <div className="d-flex align-items-center">
      <div className="icon-file">
        <i className={`text-primary icon-1 ${icons}`}></i>
      </div>
      <div className="info-file ml-2">
        <span className="font-weight-bold">{data.name}</span>
      </div>
    </div>
  );
};

const StatusFile = ({ data }) => {
  if (data.file_id) {
    if (data.verify && data.verify === 1) {
      return (
        <i
          className="icon-2x flaticon-safe-shield-protection text-success"
          title={`Verified ${moment(data.verified).format(
            "DD MMM YYYY hh:mm A"
          )}`}
        ></i>
      );
    } else {
      return (
        <i className="icon-2x flaticon-safe-shield-protection text-light"></i>
      );
    }
  } else {
    return "";
  }
};

const ButtonActions = ({ data, onFileUpload, uploadProgress, isUpload, ReloadData }) => {
  const fileInputRef = useRef(null);
  const [selectItem, setSelectItem] = useState("");

  const handleFileChange = (event, doc_type) => {
    const file = event.target.files[0];
    setSelectItem(doc_type);
    if (file) {
      const allowedExtensions = ["jpg", "jpeg", "png", "pdf"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileSize = file.size / 1024 / 1024; // size in MB

      if (!allowedExtensions.includes(fileExtension)) {
        alert("Only JPG, JPEG, PNG & PDF files are allowed!");
        return;
      }

      if (fileSize > 2) {
        alert("File size should not exceed 2MB!");
        return;
      }

      onFileUpload(file, data.id);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  const [isLoading, setIsLoading] = useState(false);
  const HandlerViewFile = async (data) => {
    setIsLoading(true);
    const objData = JSON.stringify({
      file_id: data.file_id,
      user: data.createdby,
    });
    const rsaEnc = RSAencryptData(objData);
    
    const formData = new FormData();
    formData.append("data", rsaEnc);
    formData.append("file", []);
    const download = await DOWNLOAD_REQUEST_DOC(formData);
    if(download.status === 200){
      setIsLoading(false);
      const url = URL.createObjectURL(download.data)
      if(download.data.type.startsWith("image/")){
        openModal({header: "Preview File "+data.name,message: <img src={url} className="w-100 h-100" />, size:"lg"})
      }else if(download.data.type.startsWith("application/")){
        openModal({header: "Preview File "+data.name,message: <iframe src={url} className="w-100 rounded-lg" style={{ objectFit: "cover", height: "500px" }} />, size:"lg"})
      }
    }else{
      setIsLoading(false);
      openModal({message: <PopUpMessage title={"Error"} type={"error"} message={"Failed to preview file"} />})
    }
  };

  useEffect(()=>{
    if(!isUpload){
      setSelectItem("");
    }
  },[isUpload])

  

  if (data.file_id) {
    return (
      <div className="btn-groups">
        <button className="btn btn-sm btn-light" type="button" title="Preview" onClick={()=>HandlerViewFile(data)} disabled={isLoading}>
          <i className="icon-1 flaticon-tool-1"></i>
          <span>{isLoading ? "Processing...":"View Attachment"}</span>
        </button>
        {(data.verify === 0) && (
        <button className="btn btn-sm btn-light btn-icon ml-2" type="button" title="Remove" onClick={()=>openModal({message:<ConfirmDeleteFile data={data} ReloadData={ReloadData} />})}>
          <i className="icon-1 far fa-trash-alt text-danger"></i>
        </button>
        )}
      </div>
    );
  } else {
    return (
      <>
        <div>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={(e)=>handleFileChange(e,data.id)}
            accept=".jpg,.jpeg,.png,.pdf"
          />
          <button
            className="btn btn-sm btn-light"
            type="button"
            title="Upload"
            onClick={triggerFileInput}
            disabled={selectItem === data.id && isUpload ? true : false}
          >
            <i className="icon-1 flaticon-upload"></i>
            <span>{selectItem === data.id && isUpload ? "Uploading..": "Upload file"}</span>
          </button>
        </div>
        {selectItem === data.id && Object.entries(uploadProgress).map(
          ([fileName, progress]) =>
            progress > 0 && (
              <div key={fileName} className="d-flex align-items-center mt-2">
                <div className="w-100">
                  <ProgressBar
                    striped
                    animated
                    variant="success"
                    now={progress}
                    max="100"
                  />
                </div>
                <span className="text-success ms-2">({Math.round(progress)}%)</span>
              </div>
            )
        )}
      </>
    );
  }
};

const DocStatus = ({ status }) => {
  if (status === 1) {
    return (
      <div className="d-flex align-items-center border rounded py-2 px-5 bg-success">
        <i className="icon-1 fas fa-user-check mr-3 text-white"></i>
        <span className="font-weight-bold text-white">Completed</span>
      </div>
    );
  } else {
    return (
      <div className="d-flex align-items-center border rounded py-2 px-5 bg-light">
        <i className="icon-1 fas fa-user-clock mr-3 text-dark "></i>
        <span className="font-weight-bold text-dark">Uncompleted</span>
      </div>
    );
  }
};

const ConfirmDeleteFile = ({data, ReloadData}) =>{
  const AuthToken = localStorage.getItem("AuthToken");
  const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];
  const currMail = AuthDecode.identity?.email || "";
  
  const [remove, setRemove] = useState(false);
  const handlerRemove = async () =>{
    setRemove(true);
    const param_delete_trans = {
      file_id: data.file_id,
      reff_id: data.reff_id,
    };
    console.log(param_delete_trans);
    const objData_trans = JSON.stringify(param_delete_trans);
    const rsaEnc_trans = RSAencryptData(objData_trans);
    const formData_trans = new FormData();
    formData_trans.append("data", rsaEnc_trans);
    const remove_trans_doc = await POST_DELETE_TRANS_FILE(formData_trans);
    if (remove_trans_doc.result === "success") {

      const param = {
        file_id: data.file_id,
        user: currMail,
      }
  
      const objData = JSON.stringify(param);
      const rsaEnc = RSAencryptData(objData);

      const formData = new FormData();
      formData.append("data", rsaEnc);
      const result = await DELETE_REQUEST_DOC(formData);
      if(result.result === "success"){
        openModal({open:false});
        ReloadData();
      }else{
        openModal({message: <PopUpMessage title={"Error"} type={"error"} message={"Failed to remove file"} />})
      }
    }else{
      openModal({
        message: <PopUpMessage title={"Error"} message={"Failed to remove doc transaction"} type="error" />,
      });
    }
    setRemove(false);
    
  }
  return (
    <div className="text-center">
      <div className="icon mb-5">
        <i
          className="icon-1 fas fa-exclamation-triangle text-danger"
          style={{ fontSize: "6em" }}
        ></i>
      </div>
      <h1 className="text-dark">Confirmation</h1>
      <p className="mb-10 fs-3">Are you sure want to remove?</p>
      <div className="">
        <button className="btn btn-lg btn-light mr-5" type="button" onClick={() => openModal({ open: false })} disabled={remove}>
          Cancel
        </button>
        <button className="btn btn-lg btn-danger" type="button" onClick={()=>handlerRemove()} disabled={remove}>
          {remove ? "Processing...":"Yes, remove"}
        </button>
      </div>
    </div>
  )
}

export {
  DocumentType,
  doc_type,
  MimeFile,
  StatusFile,
  ButtonActions,
  DocStatus,
  ConfirmDeleteFile
};
